import styled, { css } from "styled-components";

import type { ChipProps } from "./Chip";
import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import { CloseSmallIcon } from "../Icons";
import { Trigger } from "../Trigger";
import { StyledTypography } from "../Typography/Styles";

// prettier-ignore
export const ChipContainer = styled.div<Partial<ChipProps> & { showClose: boolean }>`
  align-items: center;
  border-radius: 0.25rem;
  display: flex;
  height: 1.5rem;
  max-width: 220px;
  overflow: hidden;
  padding-left: 0.375rem;

  ${FontStyle}
  ${BoxSizingStyle}

  background-color: var(--color-theme-400);
  color: var(--color-theme-900);
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 1.375;

  ${StyledTypography} {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${({ color }) =>
    color &&
    css`
      ${StyledTypography} {
        color: ${color};
      }
    `}

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}

  ${(props) =>
    props.showClose
      ? null
      : css`
          padding-right: 0.375rem;
        `}

  ${(props) =>
    props.size === "regular" &&
    css`
      height: 24px;
    `}

  ${(props) =>
    props.size === "small" &&
    css`
      height: 18px;
    `}

  ${(props) =>
    props.size === "big" &&
    css`
      height: 30px;
    `}

    ${(props) =>
      props.size === "biggest" &&
      css`
        height: 40px;
      `}
`;

ChipContainer.displayName = "ChipContainer";

export const ChipLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

ChipLabel.displayName = "ChipLabel";

export const ChipTrigger = styled(Trigger)<Pick<ChipProps, "size">>`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 0.125rem;

  &:hover {
    background-color: var(--color-theme-transparent-400);
  }

  ${(props) =>
    props.size === "regular" &&
    css`
      height: 24px;
      width: 24px;
    `}

  ${(props) =>
    props.size === "small" &&
    css`
      height: 18px;
      width: 18px;
    `}

  ${(props) =>
    props.size === "big" &&
    css`
      height: 30px;
      width: 30px;
    `}

    ${(props) =>
    props.size === "biggest" &&
    css`
      height: 40px;
      width: 40px;
    `}
`;

ChipTrigger.displayName = "ChipTrigger";

export const ChipCloseIcon = styled(CloseSmallIcon)`
  color: var(--color-theme-700);
`;

ChipCloseIcon.displayName = "ChipCloseIcon";
